import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { HistoricalTrendsService } from 'app/modules/historical-trends/services/historical-trends.service';
import { ReusableFunctions } from 'app/modules/shared/classes/reusable-functions';
import { DisplayOptions } from '../../../shared/interfaces/display-options';
import { MilestoneRoleVolumeByPeriod } from '../../models/MilestoneRoleVolumeByPeriod.model';
import { Router } from '@angular/router';
import { StreamgraphChartOptions } from 'app/modules/shared/classes/historical-trends-streamgraph';
import { LimeGearCharts } from 'app/modules/shared/classes/chart-data';
import { IPageHeadline } from '../../../shared/classes/page-title-parameters';
import { NoDataActionType } from '../../../shared/interfaces/no-data';
import { ILargeCardInteriorOptions } from '../../../shared/interfaces/card-data';
import * as Highcharts from 'highcharts';
import { UserAccessService } from 'app/modules/shared/services/user-access.service';
import { CustomDashboardsService } from 'app/modules/my-limegear/services/my-limegear.service';
import { ComponentsOutletDirectiveService } from 'app/modules/my-limegear/services/component-outlet-directive.service';
import { CustomDashboardsOutletDirective } from 'app/modules/my-limegear/my-limegear-outlet.directive';

interface ChartdataSeries {
    name: string;
    type: string;
    data: any[];
    marker: any;
}

interface SeriesData {
    name: string;
    data: Array<any>;
    type: string;
    color?: string;
}

@Component({
    selector: 'app-streamgraph-vol-per-level',
    templateUrl: './streamgraph-vol-per-level.component.html',
    styleUrls: ['./streamgraph-vol-per-level.component.scss'],
})
export class StreamgraphVolPerLevelComponent implements OnInit {
    constructor(
        private historicalTrendsService: HistoricalTrendsService,
        private _router: Router,
        private reusableFunctions: ReusableFunctions,
        private _userAccessService: UserAccessService,
        private customDashboardsService: CustomDashboardsService,
        private componentsOutletDirectiveService: ComponentsOutletDirectiveService,
        private cd: ChangeDetectorRef
    ) {}

    @ViewChildren(CustomDashboardsOutletDirective)
    dashboardOutlet: QueryList<CustomDashboardsOutletDirective>;

    streamGraphOptions = new StreamgraphChartOptions(this.reusableFunctions);

    colorOptions: string | string[] = [];
    hFilterJSON = '';
    displayOptions: DisplayOptions[];
    seriesData: SeriesData[];
    xCategories: Array<string>;
    dataPoint: LimeGearCharts.ChartDataPoint[];
    pageHeadline: IPageHeadline;
    action: NoDataActionType;
    largeCardInteriorOptions: ILargeCardInteriorOptions;
    dashboard = 'historical-trends';
    largeCardIdArray: Array<string>;
    pageTitle: string = 'Volume Over Time';

    ngOnInit() {
        this.pageTitle = 'Volume Over Time';
        this.setPagetitle();
        this.customDashboardsService.destroyCharts();
        this.customDashboardsService.detectChange(
            '',
            [],
            false,
            false,
            NoDataActionType.pageStart,
            this.dashboard
        );

        this.largeCardIdArray = ['historical-trends-streamgraph'];
        this.updateComponent();
        this.action = NoDataActionType.pageStart;

        // this.setFilterOptions();
        // this.prepareData();
    }

    setPagetitle() {
        this.pageHeadline = {
            module: 'historical-trends',
            moduleIcon: 'fa-chart-line',
            pageTitle: this.pageTitle,
            linkArray: [
                {
                    moduleLink: 'historical-trends',
                    linkTitle: 'Historical Trends Home',
                    showLink: true,
                    isHome: true,
                },
                {
                    moduleLink: 'historical-trends/insights',
                    linkTitle: 'Historical Trends Insights',
                    showLink: true,
                },
            ],
        };
    }

    setFilterOptions() {
        this.hFilterJSON = this.reusableFunctions.getHierarchyFilters();
    }

    applyNewFilters(event: string) {
        this.customDashboardsService.destroyCharts();
        this.hFilterJSON = event;
        this.updateComponent();
        this.customDashboardsService.detectChange(
            this.hFilterJSON,
            this.displayOptions,
            true,
            false,
            NoDataActionType.filter,
            this.dashboard
        );
    }

    updateComponent() {
        this.componentsOutletDirectiveService.detectViewChanges(this.cd);
        this.componentsOutletDirectiveService.loadContents(this.dashboardOutlet);
    }

    applyDisplayOptions(event: DisplayOptions[]) {
        this.customDashboardsService.destroyCharts();
        this.displayOptions = event;
        this.updateComponent();
        this.customDashboardsService.detectChange(
            this.hFilterJSON,
            this.displayOptions,
            false,
            true,
            NoDataActionType.filter,
            this.dashboard
        );
    }

    ngOnDestroy() {
        this.customDashboardsService.unsubscribeFilters();
        this.customDashboardsService.destroyCharts();
    }
}
